export const enClientPortalApprovalModal = {
    actions: {},
    items: {
        requestFinalisationAfterComments: 'Request finalisation of the valuation report after the comments have been incorporated',
        requestFinalisation: 'Request finalisation of the valuation report',
    },
    warningText: 'After approval, you can no longer add, edit, or delete comments on this draft.',
    confirmationLabel: 'I confirm that I approve this draft for finalisation.',
}
